package meineglasfaser.frontend.www.pages.portal.auth

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.layout.Layout
import meineglasfaser.api.routes.AuthRoutes
import meineglasfaser.frontend.common.BackendApi
import meineglasfaser.frontend.common.components.widgets.Toast
import meineglasfaser.frontend.common.components.widgets.Toasts
import meineglasfaser.frontend.common.withAuth
import meineglasfaser.frontend.www.components.CustomerState
import meineglasfaser.frontend.www.components.CustomerStateRedirectIfLoggedOut
import meineglasfaser.frontend.www.components.GlobalCustomerState
import org.jetbrains.compose.web.dom.*

@Page
@Layout(".components.layouts.ShopLayout")
@Composable
fun LogoutPage(ctx: PageContext) {
    CustomerStateRedirectIfLoggedOut()

    LaunchedEffect(Unit) {
        BackendApi.post(AuthRoutes.RealmCustomerPortal.Logout()) {
            withAuth()
        }.fold(
            onSuccess = {
                GlobalCustomerState.value = CustomerState.LoggedOut
                Toasts.display(
                    Toast.success("Erfolgreich abgemeldet")
                )
                ctx.router.navigateTo("/kundenportal/auth/login")
            },
            onFailure = { error ->
                Toasts.display(
                    Toast.error("Unerwarteter Fehler: ${error.message}")
                )
            }
        )
    }

    Div({ classes("auth-form")}) {
        H1({ classes("text-center") }) {
            Text("Abmeldung")
        }
        Div {
            P({ classes("text-center") }) {
                Span { Text("Sie werden abgemeldet, bitte warten...") }
            }
        }
    }
}
